import React from 'react';
import QuestionContainer from './QuestionContainer';
import RaisedButton from 'material-ui/RaisedButton';
var Auth = require("../../resources/auth");
var $ = require('jquery');
import notification from '../Modal/notification';
//import ReactDOM from 'react-dom';

var EditorStep2 = React.createClass({
  newQuestion: function() {
    return ({
      kquestion: {
        description: "",
        diffLevel: 0.25,
        score: 1,
        type: 11,
        solution: [],
        metadata: {},
        textInputAnswers: [],
        selectionChoices: [{
          text: "",
          image: "",
          answerValue: 1
        },{
          text: "",
          image: "",
          answerValue: 0
        },{
          text: "",
          image: "",
          answerValue: 0
        },{
          text: "",
          image: "",
          answerValue: 0
        }]
      }
    })
  },
  addQuestion: function() {
    var questions = this.state.questions;
    questions.push(this.newQuestion());
    this.setState({
      questions: questions
    })
  },
  prevStep: function() {
    this.handleStepChange(0);
  },
  nextStep: function() {
    var validation = this.validateQuestionInputFieldsBeforNavigating();

    // validate all answers (auto-marking) of long-structure question
    var answerValidation = this.validateAnswerBeforeNavigate();

    if (validation.isValid && answerValidation) {
      this.handleStepChange(2);
    }
  },
  handleStepChange: function(value) {
    this.props.onStepChange(value);
  },
  removeQuestion: function(question) {
    this.props.onQuestionRemove(question);
  },
  changeCollectionStatus: function(status) {
    this.props.changeCollectionStatus(status);
  },
  validateQuestionInputFieldsBeforNavigating: function() {
    var result = {
      isValid: true,
      invalidIndex: -1
    }
    var questions = this.state.questions;
    for (var i = 0; i < questions.length; i++) {
      var kquestion = questions[i].kquestion;
      if (!kquestion.description) {
        result.isValid = false;
        result.invalidIndex = i;
        break;
      }
      if (kquestion.type === 11) {
        for (var j = 0; j < kquestion.selectionChoices.length; j++) {
          if (!kquestion.selectionChoices[j].text && !kquestion.selectionChoices[j].image) {
            result.isValid = false;
            result.invalidIndex = i;
            break;
          }
        }
      }
      else if (kquestion.type === 21 || kquestion.type === 22) {
        for (var k = 0; k < kquestion.textInputAnswers.length; k++) {
          if (!kquestion.textInputAnswers[k].text && !kquestion.textInputAnswers[k].description) {
            result.isValid = false;
            result.invalidIndex = i;
            break;
          }
        }
      }
    }
    if (!result.isValid) {
      notification.open({
        message: 'Error',
        description: 'You must fill all fields at question ' + (result.invalidIndex+1)
      });
      $("body, html").animate({
        scrollTop: $("#question-container-" + result.invalidIndex).offset().top - 40
      })
    }
    return result;
  },

  // validate answers of auto-marking of long structure
  validateAnswerBeforeNavigate: function() {

    var questions = this.state.questions;

    for (var i = 0; i < questions.length; i++) {

      var question = questions[i];

      if (question.kquestion.type === 22) {

        var textInputAnswers = question.kquestion.textInputAnswers;

        for (var j = 0; j < textInputAnswers.length; j++) {

          var answer = textInputAnswers[j];

          if (!answer.isAnswerShown) {
            continue;
          }
        
          if (answer.isAnswerShown && !answer.text) {
            $(".alert-input-"+ i + j).text("This field is required");
            $(".answer-text-"+ i + j).focus();
            return false;
          }

          $(".alert-input-" + i + j).text("");

        }
      } 
    }
    return true;   
  },

  getInitialState: function() {
    return {
      questions: this.props.questions
    }
  },
  componentWillMount: function() {

  },
  componentWillReceiveProps: function(nextProps) {
    console.log('editor step 2 will receive prop', nextProps);
    this.setState({
      questions: nextProps.questions
    });
  },
  render: function() {
    var _this = this;
    console.log(_this.state.questions)
    return (
      <div>
        <div>
          <h3 style={{"display": "inline-block","fontSize": "20px","margin": 0,"lineHeight": "56px"}}>Total {this.state.questions.length} {this.state.questions.length > 1 ? "questions" : "question"}</h3>
          <div className="float-right" style={{"lineHeight": "56px"}}>
            <div style={{"lineHeight": "36px", "display": "inline-block"}}>
              <RaisedButton
                onClick={_this.prevStep}
                label="Change Concept"
                primary={true}
                icon={<i style={{"color": "white"}} className="fa fa-angle-left" />}
              />
            </div>
            <div style={{"lineHeight": "36px", "display": "inline-block"}}>
              <RaisedButton
                onClick={_this.nextStep}
                label="Preview & Submit"
                labelPosition="before"
                secondary={true}
                icon={<i style={{"color": "white"}} className="fa fa-angle-right" />}
              />
            </div>
          </div>
        </div>
        {
          this.state.questions.map(function(question, index) {
            return (
              <div key={index} id={"question-container-" + index}>
                <QuestionContainer
                  subject={_this.props.subject}
                  question={question}
                  questionIndex={index}
                  onQuestionRemoved={_this.removeQuestion.bind(null, question)}
                  />
              </div>
            )
          })
        }
        <div>
          <RaisedButton
            label="Add Question"
            secondary={true}
            onClick={_this.addQuestion}
          />
        </div>
      </div>
    )
  },
  componentDidMount: function() {

  }
})

export default EditorStep2;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/EditorStep2.js
 **/